import { useState } from "react";
import { t } from "i18next";
import { useMutation } from "@apollo/client";

import { ColorInput } from "../../../../../../../shared/ui/ColorInput";
import { GAME_VISUALS_UPDATE } from "../../../../../../../../graphql/mutations/GameMutation";
import { GameVisuals } from "../../../../../../../../gql/graphql";
import { Section } from "../../../Common";
import { TooltipWithIcon } from "../../../../../../../shared/ui/TooltipWithIcon";

import styles from "../Form.module.scss";

export interface OppositeColorsProps {
  gameVisuals: GameVisuals;
}

export const OppositeColors = ({ gameVisuals }: OppositeColorsProps) => {
  const [positiveColor, setPositiveColor] = useState(gameVisuals.positiveColor);
  const [negativeColor, setNegativeColor] = useState(gameVisuals.negativeColor);

  const [updateGameVisuals] = useMutation(GAME_VISUALS_UPDATE);

  const handleUpdate = () => {
    updateGameVisuals({
      variables: {
        gameVisualsId: gameVisuals.id,
        data: {
          positiveColor,
          negativeColor,
        },
      },
    });
  };

  return (
    <Section
      title={t("project:customizeVisuals.form.oppositeColors")}
      tooltip={<TooltipWithIcon content={t("project:customizeVisuals.form.oppositeColorsTooltip")} />}
      className={styles.sectionWithoutMargin}
    >
      <div className={styles.backgroundColors}>
        <Section
          title={t("project:customizeVisuals.form.positiveColor")}
          className={styles.sectionWithoutMargin}
          tooltip={<TooltipWithIcon content={t("project:customizeVisuals.form.positiveColorTooltip")} />}
        >
          <ColorInput
            value={positiveColor}
            onChange={(color) => setPositiveColor(color)}
            onBlur={handleUpdate}
          />
        </Section>
        <Section
          title={t("project:customizeVisuals.form.negativeColor")}
          className={styles.sectionWithoutMargin}
          tooltip={<TooltipWithIcon content={t("project:customizeVisuals.form.negativeColorTooltip")} />}
        >
          <ColorInput
            value={negativeColor}
            onChange={(color) => setNegativeColor(color)}
            onBlur={handleUpdate}
          />
        </Section>
      </div>
    </Section>
  );
};
